<template>
  <div class="compressed-content">
    <h3 class="page-question">You indicated that you have had a balloon opening of a blocked leg artery. What was the month and year this occurred?<br /><i>(include multiple dates if needed)</i></h3>
    <ol>
      <li v-for="(date, index) in dates" :key="index">
        {{ formatDate(date) }}
        <a role="button" @click="removeDate(index)"><svg-icon name="close" /></a>
      </li>
    </ol>
    <div class="page-buttons">
      <v-form-group :validator="$v.month" label="Month of the year">
        <b-form-input slot-scope="{ attrs, listeners }"
                      v-bind="attrs"
                      v-on="listeners"
                      v-model="month"
                      placeholder="1" />
      </v-form-group>
      <v-form-group :validator="$v.year" label="Year">
        <b-form-input slot-scope="{ attrs, listeners }"
                      v-bind="attrs"
                      v-on="listeners"
                      v-model="year"
                      placeholder="1950" />
      </v-form-group>
      <v-form-group :validator="$v.dates">
        <b-btn variant="primary" @click="addDate" :disabled="newDateDisabled">Add date</b-btn>
      </v-form-group>
    </div>
  </div>
</template>

<script>
  import formMixin from "mixins/form-mixin";
  import { required, between, numeric } from "vuelidate/lib/validators";
  import { createNamespacedHelpers } from 'vuex';
  const { mapState } = createNamespacedHelpers('survey');
  import moment from 'moment';

  export default {
    mixins: [formMixin],

    data() {
      return {
        month: null,
        year: null
      }
    },

    validations: {
      dates: {
        atLeastOneDate: required,
      },
      month: {
        numeric,
        between: between(1, 12)
      },
      year: {
        numeric,
        between: between(1950, new Date().getFullYear())
      }
    },

    computed: {
      ...mapState(["survey"]),

      dates() { return this.survey.arteryBlockages.blockedLegArteryProcedures.balloonOpeningDates; },

      newDateDisabled() {
        return !this.month || !this.year || this.$v.month.$anyError || this.$v.year.$anyError;
      }
    },

    methods: {
      addDate() {
        let date = {
          month: this.month,
          year: this.year
        };

        this.survey.arteryBlockages.blockedLegArteryProcedures.balloonOpeningDates.push(date);
      },

      removeDate(index) {
        this.survey.arteryBlockages.blockedLegArteryProcedures.balloonOpeningDates.splice(index, 1);
      },

      formatDate(date) {
        if (date.month.length == 1)
          date.month = `0${date.month}`;

        return moment(`${date.month} ${date.year}`, 'MM YYYY').format('MMMM YYYY');
      }
    }
  };
</script>